import React, { useState } from 'react';
// import axios from 'axios';
import { FiPlus, FiMinus } from 'react-icons/fi';

const faqData = [
  {
    question: "Why should I choose WETRND over other agencies?",
    answer: "WETRND delivers data-driven performance with creative strategy tailored to your brand's needs. Our proven track record and innovative approach ensure your marketing goals are not just met, but exceeded.",
  },
  {
    question: "What sets WETRND apart from the competition?",
    answer: "We blend cutting-edge technology, personalized service, and real-time analytics to ensure maximum ROI. Our team of experts provides 24/7 support and custom solutions that adapt to your business growth.",
  },
  {
    question: "How can WETRND guarantee accurate reporting?",
    answer: "With in-house tracking tools and custom dashboards, you get transparent, real-time results you can trust. Our advanced analytics platform provides detailed insights and actionable data for informed decision-making.",
  },
];

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // useEffect(() => {
  //   axios.post('http://localhost:5000/api/track', { section: 'faqs' });
  // }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faqs" className="bg-gray-50 py-20 px-4 flex justify-center">
      <div className="bg-white max-w-4xl w-full rounded-3xl shadow-2xl p-12 relative">
        {/* Header with emoji */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4 flex items-center justify-center gap-4">
            Need Help?
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
              <span className="text-2xl">👨‍💻</span>
            </div>
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div 
              key={index} 
              className="border border-gray-200 rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left flex justify-between items-center p-6 bg-white hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-inset"
              >
                <span className="text-lg font-medium text-gray-800 pr-4">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center transition-transform duration-200">
                  {openIndex === index ? (
                    <FiMinus className="text-gray-600" size={18} />
                  ) : (
                    <FiPlus className="text-gray-600" size={18} />
                  )}
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6 pt-0">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Optional: Add a subtle background pattern */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-full opacity-50 -translate-y-16 translate-x-16 -z-10"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-blue-50 to-indigo-50 rounded-full opacity-50 translate-y-12 -translate-x-12 -z-10"></div>
      </div>
    </section>
  );
};

export default FAQs;